export default __webpack_public_path__ + "static/scrolled-logo-100-84c06e3c6109131ab9a2360abddb143e.svg";